import {
    Box,
    BoxProps,
    Button,
    ButtonProps,
    Chip,
    FormControl,
    Grid,
    GridProps,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
    useTheme,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    List,
    ListItemButton,
    ListItemText,
    ListItem,
    Divider,
    LinearProgress,
    IconButtonProps,
    ListItemButtonProps,
    SvgIconProps,
    ListItemProps,
    FormControlProps,
    DialogTitleProps,
    CircularProgress,
    Link,
    Autocomplete,
} from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import EastIcon from "@mui/icons-material/East";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import * as Styles from "pages/employee/requests/requestDetails/requestDetail.styles";
import { useLocation, useParams } from "react-router-dom";
import * as applicationService from "services/application-service";
import * as attachmentService from "services/attachment-service";
import * as authenticationService from "services/AuthenticationService";
import * as certificateService from "services/certificate-service";
import * as connectiveService from "services/connective-service";
import * as processorService from "services/processor-service";
import * as departmentService from "services/department-service";
import * as userService from "services/identityUser-service";
import { statusStyleApplication } from "utilities/colorHelper";
import { AxiosError } from "axios";
import dayjs from "dayjs";
import {
    AutofpsSelect,
    CheckBox,
    ExpandLess,
    ExpandMore,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import FileUpload, { FileUploadType } from "components/formsUI/FileUpload";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ClearIcon from "@mui/icons-material/Clear";
import IncompleteModal from "./modals/IncompleteModal";
import { Message } from "components/messages/message";
import InProgressModal from "./modals/InProgressModal";
import DeleteModal from "./modals/deleteModal";
import { useAuthContext } from "contexts/authContext";
import Collapse from "components/formsUI/Collapse/Collapse";
import { blob } from "stream/consumers";
import { Console } from "console";

type Props = {
    application: ApplicationPagedDTO;
    open: boolean;
    close: any;
};

interface IProps {
    showMessage: MessageBox;
}

type ProcessorState = {
    processors: Processor[];
};

const RequestDetails = ({ showMessage }: IProps) => {
    const { applicationId } = useParams();
    const { state } = useLocation();
    // let processors = state as Processor[];
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const { user, checkAuth } = useAuthContext();

    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [errorNotFound, setErrorNotFound] = React.useState(false);
    const [errorRefused, setErrorRefused] = React.useState(false);
    const [errorIncomplete, setErrorIncomplete] = React.useState(false);
    const [errorNonSelected, setErrorNonSelected] =
        React.useState<boolean>(false);
    const [errorPositive, setErrorPositive] = React.useState(false);
    const [errorInProgress, setErrorInProgress] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [signingInProgress, setSigningInProgress] = React.useState(false);
    const [departments, setDepartments] = React.useState<string[]>([]);

    const [request, setRequest] = React.useState<ApplicationWithDetails>();
    const [certificate, setCertificate] = React.useState<string>();
    const [processors, setProcessors] = React.useState<Processor[]>();
    const [hasReadInProgress, setHasReadInProgress] =
        React.useState<boolean>(false);
    const [orgnisationDisabled, setOrgnisationDisabled] =
        React.useState<boolean>(false);
    const [files, _setFiles] = React.useState<FileUploadType[]>([]);

    const setFiles = (files: FileUploadType[]): void => {
        const temp = request;
        const newFiles = files.map((file) => {
            const requestFile = request?.attachments.find(
                (f) => f.id === file.id,
            );
            let newFile: AttachmentWithDetails;
            if (requestFile) {
                newFile = requestFile;
            } else {
                newFile = {
                    id: file.id,
                    hash: "",
                    name: file.file.name,
                    size: file.file.size,
                    type: file.file.type,
                    fileType: file.type,
                    isEditable: true,
                    storageName: "",
                    isManualSigned: false,
                    applicationId: applicationId,
                    isCorrespondentie: false,
                };
            }
            return newFile;
        });
        if (temp) {
            temp.attachments = newFiles;
        }
        setRequest(temp);
        _setFiles(files);
    };

    const incompleteRef =
        React.useRef<React.ElementRef<typeof IncompleteModal>>(null);

    const showError = (message: string) => {
        setErrorMessage(message);
        setShowErrorMessage(true);
    };

    const fetchRequest = (loading: boolean = true) => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorNotFound(false);
        if (loading) {
            setRequest(undefined);
        }
        setIsLoading(loading);
        if (applicationId && (request === undefined || !loading)) {
            applicationService
                .getApplicationWithDetails(applicationId)
                .then((res: ApplicationWithDetails) => {
                    setIsLoading(false);
                    setRequest(res);
                    if (!processors) {
                        fethProcessors();
                    }
                    if (
                        (res.status === "Gunstig" ||
                            res.status === "Positief" ||
                            res.status === "PositiefWaarschuwing") &&
                        checkAuth(
                            [
                                "BeheerAttesten",
                                "ControleAttesten",
                                "IntrekkenAttesten",
                                "OpvolgenAttesten",
                            ],
                            false,
                        )
                    ) {
                        certificateService
                            .getByApplicationId(applicationId)
                            .then((res) => {
                                if (res) {
                                    setCertificate(res.id);
                                } else {
                                    setCertificate("");
                                }
                            });
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setIsLoading(false);
                    if (error.response?.status === 404) {
                        showError(`${t("requestWithDetail.errorNotFound")}`);
                        setErrorNotFound(true);
                    } else {
                        showError(`${t("requestWithDetail.errorServer")}`);
                    }
                });
        } else {
            showError(`${t("requestWithDetail.errorNotFound")}`);
            setErrorNotFound(true);
        }
    };

    const changeProcessor = (event: SelectChangeEvent) => {
        setErrorMessage("");
        setShowErrorMessage(false);
        var processorId;
        if (processors)
            processorId = processors.find(
                (p) => `${p.firstName} ${p.lastName}` === event.target.value,
            )?.id;
        if (applicationId && processorId) {
            applicationService
                .updateApplicationProcessor(applicationId, processorId)
                .then((res: ApplicationWithDetails) => {
                    if (request) {
                        const temp = {
                            ...request,
                            processor: res.processor,
                            status: res.status,
                            statusHistories: res.statusHistories,
                        };
                        setRequest(temp);
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    showError(`${t("requestWithDetail.errorServerUpdate")}`);
                });
        }
    };

    const fethProcessors = () => {
        if (!orgnisationDisabled) {
            processorService
                .getProcessors("Processor")
                .then((res: Processor[]) => {
                    setProcessors(res);
                })
                .catch((error: AxiosError<Error>) => {});
        }
    };

    useEffect(() => {
        if (applicationId && request === undefined) {
            setProcessors(state as Processor[]);
            fetchRequest();
        }
        if (departments?.length <= 0) {
            departmentService.getDepartmentNames().then((res) => {
                setDepartments([...res]);
            });
        }
        let enable: boolean = false;
        setOrgnisationDisabled(false);
        if (checkAuth(["External"]) && !checkAuth(["Employee"])) {
            console.log("external");
            setOrgnisationDisabled(true);
            enable = true;
        }
        if (request !== undefined) getFiles(enable);
    }, [request]);

    //Refuse properties

    const [openRefuse, setOpenRefuse] = React.useState(false);
    const handleOpenRefuse = () => setOpenRefuse(true);
    const handleCloseRefuse = () => setOpenRefuse(false);
    const [motivationRefuse, setMotivationRefuse] = React.useState("");

    const handleConfirmRefuse = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorRefused(false);
        if (motivationRefuse !== "" && request && applicationId) {
            applicationService
                .updateApplicationStatusSpecific(
                    applicationId,
                    motivationRefuse,
                    "refused",
                )
                .then((res: ApplicationWithDetails) => {
                    if (request) {
                        const temp = {
                            ...request,
                            status: res.status,
                            statusHistories: res.statusHistories,
                        };
                        setRequest(temp);
                        handleCloseRefuse();
                        setMotivationRefuse("");
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setErrorRefused(true);
                    showError(`${t("requestWithDetail.errorServerUpdate")}`);
                });
        }
    };

    const handleCloseRefuseDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleCloseRefuse();
    };

    const handleGoToCertificate = (): void => {
        navigate(`/beheer/attesten/${certificate}`);
    };

    // Delete properties

    const [openDelete, setOpenDelete] = React.useState<boolean>(false);
    const handleOpenDelete = () => setOpenDelete(true);
    const handleCloseDelete = () => setOpenDelete(false);

    //In progress properties

    const [openInProgress, setOpenInProgress] = React.useState(false);
    const handleOpenInProgress = () => setOpenInProgress(true);
    const handleCloseInProgress = () => setOpenInProgress(false);

    const handleCloseInProgressDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleCloseInProgress();
    };

    const handleConfirmInProgress = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorInProgress(false);
        if (request && applicationId) {
            applicationService
                .updateApplicationStatusSpecific(
                    applicationId,
                    "",
                    "inProgress",
                )
                .then((res: ApplicationWithDetails) => {
                    if (request) {
                        const temp: ApplicationWithDetails = {
                            ...request,
                            applicationSignedFile: res.applicationSignedFile,
                            status: res.status,
                            statusHistories: res.statusHistories,
                        };
                        temp.attachments = temp.attachments.filter(
                            (a) =>
                                a.isManualSigned === false &&
                                a.type !== "preview",
                        );
                        setRequest(temp);
                        handleCloseInProgress();
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setErrorInProgress(true);
                    showError(`${t("requestWithDetail.errorServerUpdate")}`);
                });
        }
    };

    //Positive properties

    const [openPositive, setOpenPositive] = React.useState(false);
    const [positiveIsLoading, setPositiveIsLoading] = React.useState(false);
    const handleOpenPositive = () => setOpenPositive(true);
    const handleClosePositive = () => setOpenPositive(false);

    const handleClosePositiveDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleClosePositive();
    };

    const [openPositiveRemark, setOpenPositiveRemark] = React.useState(false);
    const [positiveIsLoadingRemark, setPositiveIsLoadingRemark] =
        React.useState(false);
    const handleOpenPositiveRemark = () => setOpenPositiveRemark(true);
    const handleClosePositiveRemark = () => setOpenPositiveRemark(false);
    const [positiveRemarkMotivation, setPositiveRemarkMotivation] =
        React.useState("");

    const handleClosePositiveRemarkDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleClosePositiveRemark();
    };

    const handleConfirmPositiveRemark = (): void => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorPositive(false);
        setPositiveIsLoadingRemark(true);
        if (request && applicationId) {
            applicationService
                .updateApplicationStatusSpecific(
                    applicationId,
                    positiveRemarkMotivation,
                    "positiveremark",
                )
                .then((res: ApplicationWithDetails) => {
                    if (request) {
                        const temp = {
                            ...request,
                            status: res.status,
                            statusHistories: res.statusHistories,
                            attachments: res.attachments,
                        };
                        setRequest(temp);
                        handleClosePositiveRemark();
                        setPositiveIsLoadingRemark(false);
                        certificateService
                            .getByApplicationId(applicationId)
                            .then((data) => {
                                if (data) {
                                    setCertificate(data.id);
                                } else {
                                    setCertificate("");
                                }
                            });
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setErrorPositive(true);
                    setPositiveIsLoading(false);
                    showError(`${t("requestWithDetail.errorServerUpdate")}`);
                });
        }
    };

    const handleConfirmPositive = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorPositive(false);
        setPositiveIsLoading(true);
        if (request && applicationId) {
            applicationService
                .updateApplicationStatusSpecific(applicationId, "", "positive")
                .then((res: ApplicationWithDetails) => {
                    if (request) {
                        const temp = {
                            ...request,
                            status: res.status,
                            statusHistories: res.statusHistories,
                            attachments: res.attachments,
                        };
                        setRequest(temp);
                        handleClosePositive();
                        setPositiveIsLoading(false);
                        certificateService
                            .getByApplicationId(applicationId)
                            .then((data) => {
                                if (data) {
                                    setCertificate(data.id);
                                } else {
                                    setCertificate("");
                                }
                            });
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setErrorPositive(true);
                    setPositiveIsLoading(false);
                    showError(`${t("requestWithDetail.errorServerUpdate")}`);
                });
        }
    };

    //Incomplete properties

    const [openIncomplete, setOpenIncomplete] = React.useState(false);
    const handleOpenIncomplete = () => setOpenIncomplete(true);
    const handleCloseIncomplete = () => setOpenIncomplete(false);
    const [motivationIncomplete, setMotivationIncomplete] = React.useState("");

    const handleConfirmIncomplete = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorIncomplete(false);
        setErrorNonSelected(false);
        let incompleteStep: number = 25;
        if (incompleteRef) {
            incompleteStep = incompleteRef.current.getStep();
        }
        if (
            motivationIncomplete !== "" &&
            request &&
            applicationId &&
            incompleteStep !== 25
        ) {
            applicationService
                .updateApplicationStatusSpecific(
                    applicationId,
                    motivationIncomplete,
                    "incomplete",
                    incompleteStep,
                )
                .then((res: ApplicationWithDetails) => {
                    if (request) {
                        const temp = {
                            ...request,
                            status: res.status,
                            statusHistories: res.statusHistories,
                        };
                        setRequest(temp);
                        handleCloseIncomplete();
                        setMotivationIncomplete("");
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setErrorIncomplete(true);
                    showError(`${t("requestWithDetail.errorServerUpdate")}`);
                });
        }
        if (incompleteStep === 25) {
            setErrorNonSelected(true);
            showError(`${t("requestWithDetail.errorNonSelected")}`);
        }
    };

    const handleCloseIncompleteDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleCloseIncomplete();
    };

    const handleDownloadRequest = (): void => {
        console.log("download the attest got from connective");
        applicationService
            .getSignedFile(applicationId as string)
            .then((res: Blob) => {
                if (res !== undefined) {
                    var fileUrl = URL.createObjectURL(res);
                    var fileName = "unknown.pdf";
                    if (request) {
                        fileName = request.applicationSignedFile.substring(
                            request.applicationSignedFile.indexOf("_") + 1,
                        );
                    }
                    const link = document.createElement("a");
                    link.href = fileUrl;
                    link.download = fileName;
                    link.click();
                }
            });
    };

    let interval: NodeJS.Timer | undefined | boolean;

    const openDocumentToSign = () => {
        setErrorIncomplete(false);
        setSigningInProgress(true);
        if (request) {
            connectiveService
                .getPackageRemainingActionsEmployee(request.packageId as string)
                .then((res: string[]) => {
                    if (res.length !== 0) {
                        window.open(res[0], "_blank", "noreferrer");
                    }

                    interval = setInterval(() => {
                        checkSigningStatus();
                    }, 5000);
                })
                .catch((error: AxiosError<Error>) => {
                    setSigningInProgress(false);
                    setErrorIncomplete(true);
                    showError(`${t("requestWithDetail.errorServerSign")}`);
                });
        }
    };

    // const [isChecking, setIsChecking] = React.useState(false);
    let isChecking = false;

    const checkSigningStatus = () => {
        if (!isChecking) {
            isChecking = true;
            console.log("interval");
            applicationService
                .checkPackageStatus(applicationId as string)
                .then((res: boolean) => {
                    isChecking = false;
                    if (res && request && interval) {
                        request.applicationSignedFile = "Signed";
                        setSigningInProgress(false);
                        clearInterval(interval as NodeJS.Timer);
                        fetchRequest();
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    isChecking = false;
                });
        }
    };

    //  --- Props ---
    const subtitle: BoxProps = {
        component: "h3",
        sx: Styles.subtitle(theme),
    };

    const wrapper: BoxProps = {
        sx: Styles.wrapper(theme),
    };

    const errorWrapper: BoxProps = {
        sx: Styles.errorWrapper(theme),
    };

    const statuswrapper: GridProps = {
        sx: Styles.statusWrapper(theme),
    };

    const statusButton: ButtonProps = {
        sx: Styles.statusButton(theme),
        variant: "contained",
    };

    const statusListItem: ListItemProps = {
        sx: Styles.statusListItem(theme),
    };

    const statusChipsWrapper: BoxProps = {
        sx: Styles.statusChipsWrapper(theme),
    };

    const statusArrowIcon: SvgIconProps = {
        sx: Styles.statusArrowIcon(theme),
    };

    const selectProcessorWrapper: BoxProps = {
        sx: Styles.selectProcessorWrapper(theme),
    };

    const selectProcessor: FormControlProps = {
        sx: Styles.selectProcessor(theme),
    };

    const requestInfoWrapper: GridProps = {
        sx: Styles.requestInfoWrapper(theme),
    };

    const statusDialogTitle: DialogTitleProps = {
        sx: Styles.statusDialogTitle(theme),
    };

    const statusDialogCancelButton: ButtonProps = {
        variant: "contained",
        // sx: Styles.statusDialogCancelButton(theme)
        color: "cancel",
    };

    const closeDialogIconButton: IconButtonProps = {
        sx: Styles.closeDialogIconButton(theme),
    };

    const collapseGridContainer: GridProps = {
        container: true,
        item: true,
        spacing: 2,
        md: 12,
        xs: 12,
        justifyContent: "center",
        sx: {
            marginLeft: "0.75rem",
            marginBottom: "0.75rem",
        },
    };

    const disableIfDone = (): boolean => {
        if (
            (request !== undefined && request.status === "Gunstig") ||
            (request !== undefined && request.status === "Geweigerd")
        ) {
            return true;
        }
        if (!checkAuth(["BeheerAanvraag"])) {
            return true;
        }
        return false;
    };

    const disableIfNotRefused = (): boolean => {
        if (request !== undefined && request.status === "Geweigerd") {
            return false;
        }
        return true;
    };

    const getFiles = (enable: boolean = false): void => {
        if (request !== undefined) {
            const attachements = request.attachments.map((attachement) => {
                const type = attachement.type.split("/");

                if (attachement.fileType === "") {
                    if (
                        !attachement.isManualSigned &&
                        !attachement.isCorrespondentie &&
                        attachement.isEditable
                    ) {
                        attachement.fileType = "Databank bevraging";
                    } else if (
                        !attachement.isManualSigned &&
                        attachement.isCorrespondentie &&
                        attachement.isEditable
                    ) {
                        attachement.fileType = "Correspondentie";
                    } else if (
                        attachement.isManualSigned &&
                        !attachement.isCorrespondentie &&
                        !attachement.isEditable
                    ) {
                        attachement.fileType = "Aanvraagformulier";
                    } else if (
                        !attachement.isManualSigned &&
                        !attachement.isCorrespondentie &&
                        !attachement.isEditable
                    ) {
                        attachement.fileType = "Uittreksel strafregister";
                    }
                }

                let disable = true;
                if (request.status !== "Geweigerd") {
                    disable = attachement.fileType === "Databank bevraging";
                } else {
                    disable = attachement.fileType === "Correspondentie";
                }
                // Causing long loading times because it creates an new empty file with the size of the attachement, so we will just create an empty file with the name and type
                attachement.size = 0;
                const file: FileUploadType = {
                    id: attachement.id as string,
                    file: new File(
                        new Array<BlobPart>(attachement.size),
                        attachement.name,
                        { type: attachement.type },
                    ),
                    progress: 100,
                    extension: type[type.length - 1],
                    dbId: attachement.id,
                    disable: !disable,
                    type: attachement.fileType,
                };
                return file;
            });
            if (
                (request.signingState === "Signed" ||
                    request.signingState === "Manual") &&
                checkAuth(["BeheerAanvraag"]) &&
                !orgnisationDisabled &&
                request.applicationSignedFile !== "Signed" &&
                request.applicationSignedFile !== null
            ) {
                applicationService
                    .getSignedFileInfo(applicationId as string)
                    .then((res: Blob) => {
                        if (res !== undefined) {
                            const fileName = request
                                ? request.applicationSignedFile.substring(
                                      request.applicationSignedFile.indexOf(
                                          "_",
                                      ) + 1,
                                  )
                                : "unknow.pdf";
                            const id = request
                                ? request.applicationSignedFile.substring(
                                      0,
                                      request.applicationSignedFile.indexOf(
                                          "_",
                                      ),
                                  )
                                : "";
                            const file: FileUploadType = {
                                id: id,
                                file: new File(
                                    new Array<BlobPart>(res),
                                    fileName,
                                    {
                                        type: res.type,
                                    },
                                ),
                                progress: 100,
                                extension: "pdf",
                                dbId: id,
                                disable: true,
                                type: "Aanvraagformulier",
                            };
                            attachements.push(file);
                        }
                        const requestForm = attachements.filter(
                            (a) => a.type === "Aanvraagformulier",
                        );
                        const vertr = attachements.filter(
                            (a) => a.type === "Vertrouwelijkheidsovereenkomst",
                        );
                        const straf = attachements.filter(
                            (a) => a.type === "Uittreksel strafregister",
                        );
                        const databank = attachements.filter(
                            (a) => a.type === "Databank bevraging",
                        );
                        const correspond = attachements.filter(
                            (a) => a.type === "Correspondentie",
                        );
                        setFiles([
                            requestForm[0],
                            ...vertr,
                            ...straf,
                            ...databank,
                            ...correspond,
                        ]);
                    })
                    .catch((err) => {
                        const straf = attachements.filter(
                            (a) => a.type === "Uittreksel strafregister",
                        );
                        const vertr = attachements.filter(
                            (a) => a.type === "Vertrouwelijkheidsovereenkomst",
                        );
                        const databank = attachements.filter(
                            (a) => a.type === "Databank bevraging",
                        );
                        const correspond = attachements.filter(
                            (a) => a.type === "Correspondentie",
                        );
                        const requestForm = attachements.filter(
                            (a) => a.type === "Aanvraagformulier",
                        );
                        if (requestForm[0]) {
                            setFiles([
                                requestForm[0],
                                ...vertr,
                                ...straf,
                                ...databank,
                                ...correspond,
                            ]);
                        } else {
                            setFiles([
                                ...vertr,
                                ...straf,
                                ...databank,
                                ...correspond,
                            ]);
                        }
                    });
            } else {
                const requestForm = attachements.filter(
                    (a) => a.type === "Aanvraagformulier",
                );
                const vertr = attachements.filter(
                    (a) => a.type === "Vertrouwelijkheidsovereenkomst",
                );
                const straf = attachements.filter(
                    (a) => a.type === "Uittreksel strafregister",
                );
                const databank = attachements.filter(
                    (a) => a.type === "Databank bevraging",
                );
                const correspond = attachements.filter(
                    (a) => a.type === "Correspondentie",
                );

                if (
                    requestForm.length == 0 &&
                    checkAuth(["BeheerAanvraag", "WeigerenAanvraag"], false) &&
                    !request.isManuallySigned &&
                    request.packageId !== null
                ) {
                    requestForm.push({
                        id: "",
                        file: new File(
                            [],
                            "Preview " + t("settings.documents.request"),
                            {
                                type: "Preview",
                            },
                        ),
                        progress: 100,
                        extension: "",
                        dbId: request.packageId,
                        disable: true,
                        type: "Aanvraagformulier",
                        preview: true,
                    });

                    if (request.hasVertrouwelijk) {
                        vertr.push({
                            id: "",
                            file: new File(
                                [],
                                "Preview " +
                                    t("settings.documents.vertrouwelijk"),
                                { type: "Preview" },
                            ),
                            progress: 100,
                            extension: "",
                            dbId: request.packageId,
                            disable: true,
                            type: "Vertrouwelijkheidsovereenkomst",
                            preview: true,
                        });
                    }
                }

                if (requestForm[0]) {
                    const files = [
                        requestForm[0],
                        ...vertr,
                        ...straf,
                        ...databank,
                        ...correspond,
                    ];
                    setFiles(files);
                } else {
                    setFiles([...vertr, ...straf, ...databank, ...correspond]);
                }
            }
        }
    };

    const LocalFileUpload = () => {
        return (
            <div>
                {request !== undefined && (
                    <FileUpload
                        showMessage={showMessage}
                        setFilesUploaded={(e) => console.log(e)}
                        getFiles={setFiles}
                        fileUploads={files}
                        clickable={true}
                        textUpload={
                            request.status !== "Geweigerd"
                                ? t("requestWithDetail.upload")
                                : t("requestWithDetail.uploadCor")
                        }
                        disable={
                            request.status === "Gunstig" ||
                            request.status === "Positief" ||
                            request.status === "PositiefWaarschuwing" ||
                            orgnisationDisabled
                        }
                        backgroundColor="white"
                        title=""
                        detailPage={true}
                    />
                )}
            </div>
        );
    };

    return (
        <Box {...wrapper}>
            {/* <ArrowBackIcon sx={{position: "absolute", padding: "10px", fontSize: "30px", "&:hover": { cursor: "pointer" }}} onClick={() => navigate(-1)}/> */}
            <Box sx={{ padding: "15px" }}>
                <h1 style={{ marginTop: "0" }}>
                    <ArrowBackIcon
                        sx={{
                            padding: "0",
                            fontSize: "25px",
                            marginRight: "5px",
                            "&:hover": { cursor: "pointer" },
                        }}
                        onClick={() => navigate(-1)}
                    />
                    {t("requestWithDetail.title")} -{" "}
                    {request?.applicant?.firstName}{" "}
                    {request?.applicant?.lastName}
                </h1>
                {isLoading && <LinearProgress />}
                {showErrorMessage &&
                    !errorRefused &&
                    !errorIncomplete &&
                    !errorPositive &&
                    !errorInProgress && (
                        <Box {...errorWrapper}>
                            <Box color="error.main">
                                {errorMessage}
                                <Box sx={{ marginTop: "5px" }}>
                                    {errorNotFound && (
                                        <Button
                                            color="error"
                                            variant="outlined"
                                            onClick={() => navigate(-1)}
                                        >
                                            {t("requestWithDetail.goBack")}
                                        </Button>
                                    )}
                                    {!errorNotFound && (
                                        <Button
                                            color="error"
                                            variant="outlined"
                                            onClick={() => navigate(0)}
                                        >
                                            {t("requestWithDetail.reload")}
                                        </Button>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    )}
                {request !== undefined && (
                    <Box>
                        <Box>
                            <Grid container {...statuswrapper}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        mb: { xs: "10px", sm: 0 },
                                        alignSelf: "center",
                                    }}
                                >
                                    <Box>
                                        <b>{t("requestsTableHeader.status")}</b>
                                        <Chip
                                            sx={{
                                                marginLeft: "10px",
                                                backgroundColor:
                                                    statusStyleApplication(
                                                        request.status,
                                                    ),
                                                color: "white",
                                            }}
                                            label={t(request.status)}
                                        />
                                        <br></br>
                                        {checkAuth(
                                            ["BeheerAanvraag"],
                                            false,
                                        ) && (
                                            <Box {...selectProcessorWrapper}>
                                                <Box minWidth={100}>
                                                    <b>
                                                        {t(
                                                            "requestsTableHeader.processor",
                                                        )}
                                                    </b>
                                                </Box>
                                                <FormControl
                                                    {...selectProcessor}
                                                    size="small"
                                                >
                                                    {processors && (
                                                        <Select
                                                            sx={{
                                                                width: "150px",
                                                                backgroundColor:
                                                                    "white",
                                                            }}
                                                            disabled={
                                                                request.status ===
                                                                    "Geweigerd" ||
                                                                request.status ===
                                                                    "Gunstig" ||
                                                                request.status ===
                                                                    "Positief" ||
                                                                request.status ===
                                                                    "PositiefWaarschuwing"
                                                            }
                                                            displayEmpty
                                                            id="processor-select"
                                                            value={
                                                                request.processor
                                                                    ? `${request.processor?.firstName} ${request.processor?.lastName}`
                                                                    : ""
                                                            }
                                                            onChange={
                                                                changeProcessor
                                                            }
                                                        >
                                                            {processors.map(
                                                                (name) => (
                                                                    <MenuItem
                                                                        key={
                                                                            name.id
                                                                        }
                                                                        value={`${name.firstName} ${name.lastName}`}
                                                                    >
                                                                        {
                                                                            name.firstName
                                                                        }{" "}
                                                                        {
                                                                            name.lastName
                                                                        }
                                                                    </MenuItem>
                                                                ),
                                                            )}
                                                        </Select>
                                                    )}
                                                </FormControl>
                                            </Box>
                                        )}
                                        {/*<Box {...selectProcessorWrapper}>
                                            <Box minWidth={100}>
                                                <b>
                                                    {t(
                                                        "requestsTableHeader.department",
                                                    )}
                                                </b>
                                            </Box>
                                            <FormControl
                                                {...selectProcessor}
                                                size="small"
                                            >
                                                {processors && (
                                                    <Box>
                                                        <Autocomplete
                                                            sx={{
                                                                backgroundColor:
                                                                    "white",
                                                            }}
                                                            options={
                                                                departments
                                                            }
                                                            value={
                                                                request
                                                                    ?.department
                                                                    ?.name
                                                            }
                                                            // disabled={request.status === "Geweigerd" || request.status === "Gunstig" || orgnisationDisabled}
                                                            disabled={
                                                                orgnisationDisabled
                                                            }
                                                            onChange={(
                                                                event: any,
                                                                value:
                                                                    | string
                                                                    | null,
                                                            ) => {
                                                                changeDepartment(
                                                                    event,
                                                                    value,
                                                                );
                                                            }}
                                                            renderInput={(
                                                                params,
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    sx={{
                                                                        width: "150px",
                                                                    }}
                                                                    size="small"
                                                                />
                                                            )}
                                                            renderOption={(
                                                                props,
                                                                option,
                                                            ) => (
                                                                <MenuItem
                                                                    {...props}
                                                                    key={option}
                                                                    value={
                                                                        option
                                                                    }
                                                                >
                                                                    {option ===
                                                                    ""
                                                                        ? "Geen departement"
                                                                        : option}
                                                                </MenuItem>
                                                            )}
                                                            clearIcon={
                                                                <ClearIcon
                                                                    fontSize="small"
                                                                    onClick={() => {
                                                                        changeDepartment(
                                                                            null,
                                                                            "",
                                                                        );
                                                                    }}
                                                                />
                                                            }
                                                        />
                                                    </Box>
                                                )}
                                            </FormControl>
                                        </Box>*/}
                                        {/* {request !== undefined && request.isManuallySigned &&
                                            request.attachments.filter(a => a.isManualSigned === true).length !== 0 &&
                                            <Box sx={Styles.downloadWrapper(theme)}>
                                                <DownloadIcon />
                                                <Link component="button" variant="body2" onClick={() => { handleDownloadManuallyFile(); }}>
                                                    {t('requestWithDetail.download')}
                                                </Link>
                                            </Box>
                                        }
                                        {(request.applicationSignedFile && request.applicationSignedFile?.length !== 0) &&
                                            <Box sx={Styles.downloadWrapper(theme)}>
                                                <DownloadIcon />
                                                <Link component="button" variant="body2" onClick={() => { handleDownloadRequest(); }}>
                                                    {t('requestWithDetail.download')}
                                                </Link>
                                            </Box>
                                        } */}
                                        {checkAuth([
                                            "VerwijderenAanvragen",
                                        ]) && (
                                            <Box
                                                sx={Styles.downloadWrapper(
                                                    theme,
                                                )}
                                            >
                                                <DeleteForeverIcon />
                                                <Link
                                                    component="button"
                                                    variant="body2"
                                                    onClick={handleOpenDelete}
                                                >
                                                    {t(
                                                        "requestWithDetail.deleteButton",
                                                    )}
                                                </Link>
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                                {checkAuth(
                                    ["BeheerAanvraag", "WeigerenAanvraag"],
                                    false,
                                ) &&
                                    request?.status !== "Geweigerd" &&
                                    request?.status !== "Gunstig" &&
                                    request?.status !== "Positief" &&
                                    request?.status !==
                                        "PositiefWaarschuwing" && (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            sx={{ textAlign: { sm: "end" } }}
                                            columnSpacing={1}
                                        >
                                            <Box>
                                                {checkAuth([
                                                    "BeheerAanvraag",
                                                ]) &&
                                                    (request.status ===
                                                        "Ingediend" ||
                                                        request.status ===
                                                            "Onvolledig") && (
                                                        <Button
                                                            {...statusButton}
                                                            onClick={
                                                                handleOpenInProgress
                                                            }
                                                            color="success"
                                                        >
                                                            {t(
                                                                "requestWithDetail.inProgress.button",
                                                            )}
                                                        </Button>
                                                    )}
                                                {checkAuth([
                                                    "BeheerAanvraag",
                                                ]) &&
                                                    request?.status !==
                                                        "Onvolledig" &&
                                                    request.status !==
                                                        "In behandeling" &&
                                                    request.status !==
                                                        "Geweigerd" &&
                                                    request.status !==
                                                        "Opgestart" && (
                                                        <Button
                                                            {...statusButton}
                                                            onClick={
                                                                handleOpenIncomplete
                                                            }
                                                            color="error"
                                                        >
                                                            {t(
                                                                "requestWithDetail.incomplete.button",
                                                            )}
                                                        </Button>
                                                    )}
                                                {checkAuth([
                                                    "BeheerAanvraag",
                                                ]) &&
                                                    request.status ===
                                                        "In behandeling" && (
                                                        <Button
                                                            {...statusButton}
                                                            onClick={
                                                                handleOpenPositive
                                                            }
                                                            color="success"
                                                        >
                                                            {t(
                                                                "requestWithDetail.positive.button",
                                                            )}
                                                        </Button>
                                                    )}

                                                {checkAuth([
                                                    "WeigerenAanvraag",
                                                ]) &&
                                                    (request.status ===
                                                        "In behandeling" ||
                                                        request.status ===
                                                            "Onvolledig") && (
                                                        <Button
                                                            {...statusButton}
                                                            onClick={
                                                                handleOpenRefuse
                                                            }
                                                            color="error"
                                                        >
                                                            {t(
                                                                "requestWithDetail.refuse.button",
                                                            )}
                                                        </Button>
                                                    )}
                                                {checkAuth([
                                                    "BeheerAanvraag",
                                                ]) &&
                                                    request.status ===
                                                        "In behandeling" && (
                                                        <Button
                                                            {...statusButton}
                                                            onClick={
                                                                handleOpenPositiveRemark
                                                            }
                                                            color="warning"
                                                        >
                                                            {t(
                                                                "requestWithDetail.positiveRemark.button",
                                                            )}
                                                        </Button>
                                                    )}
                                            </Box>
                                        </Grid>
                                    )}
                                {checkAuth(
                                    [
                                        "BeheerAttesten",
                                        "ControleAttesten",
                                        "IntrekkenAttesten",
                                        "OpvolgenAttesten",
                                    ],
                                    false,
                                ) &&
                                    (request?.status === "Gunstig" ||
                                        request?.status === "Positief" ||
                                        request?.status ===
                                            "PositiefWaarschuwing") &&
                                    certificate !== "" && (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            sx={{
                                                textAlign: { sm: "end" },
                                                alignSelf: "center",
                                            }}
                                            columnSpacing={1}
                                        >
                                            <Box>
                                                <Button
                                                    {...statusButton}
                                                    onClick={
                                                        handleGoToCertificate
                                                    }
                                                >
                                                    {t(
                                                        "requestWithDetail.goCertificate",
                                                    )}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    )}
                            </Grid>
                        </Box>

                        <Collapse title={t("requestWithDetail.historyStatus")}>
                            <List component="div" disablePadding>
                                {request?.statusHistories
                                    .sort(
                                        (a, b) =>
                                            new Date(a.creationTime).getTime() -
                                            new Date(b.creationTime).getTime(),
                                    )
                                    .map((statusHistory, index) => (
                                        <Box key={statusHistory.id}>
                                            <ListItem {...statusListItem}>
                                                <Box>
                                                    <Box
                                                        {...statusChipsWrapper}
                                                    >
                                                        <Chip
                                                            label={
                                                                statusHistory.statusFrom ===
                                                                ""
                                                                    ? t(
                                                                          "Opgestart",
                                                                      )
                                                                    : t(
                                                                          statusHistory.statusFrom,
                                                                      )
                                                            }
                                                            sx={{
                                                                backgroundColor:
                                                                    statusStyleApplication(
                                                                        statusHistory.statusFrom,
                                                                    ),
                                                                color: "white",
                                                            }}
                                                        />
                                                        <EastIcon
                                                            {...statusArrowIcon}
                                                        />
                                                        <Chip
                                                            label={t(
                                                                statusHistory.statusTo,
                                                            )}
                                                            sx={{
                                                                backgroundColor:
                                                                    statusStyleApplication(
                                                                        statusHistory.statusTo,
                                                                    ),
                                                                color: "white",
                                                            }}
                                                        />
                                                    </Box>
                                                    {statusHistory.employeePolice ? (
                                                        <ListItemText
                                                            primary={
                                                                statusHistory.statusTo ===
                                                                    "Geweigerd" &&
                                                                !checkAuth([
                                                                    "WeigerenAanvraag",
                                                                ])
                                                                    ? ""
                                                                    : statusHistory.comment
                                                            }
                                                            secondary={
                                                                dayjs(
                                                                    statusHistory.creationTime,
                                                                )
                                                                    .format(
                                                                        "DD/MM/YYYY",
                                                                    )
                                                                    .toString() +
                                                                " " +
                                                                t(
                                                                    "requestWithDetail.by",
                                                                ) +
                                                                " " +
                                                                statusHistory
                                                                    .employeePolice
                                                                    ?.firstName +
                                                                " " +
                                                                statusHistory
                                                                    .employeePolice
                                                                    ?.lastName
                                                            }
                                                        />
                                                    ) : statusHistory.statusFrom ===
                                                          "Opgestart" ||
                                                      statusHistory.statusFrom ===
                                                          "Onvolledig" ||
                                                      statusHistory.statusFrom ===
                                                          "" ? (
                                                        <ListItemText
                                                            primary={
                                                                statusHistory.comment ===
                                                                    "Aanvraag ingediend" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag vervolledigd" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag in behandeling genomen" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag opnieuw in behandeling genomen" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag manueel ingediend"
                                                                    ? t(
                                                                          statusHistory.comment,
                                                                      )
                                                                    : statusHistory.comment
                                                            }
                                                            secondary={
                                                                dayjs(
                                                                    statusHistory.creationTime,
                                                                )
                                                                    .format(
                                                                        "DD/MM/YYYY",
                                                                    )
                                                                    .toString() +
                                                                " " +
                                                                t(
                                                                    "requestWithDetail.by",
                                                                ) +
                                                                " " +
                                                                request
                                                                    ?.applicant
                                                                    ?.firstName +
                                                                " " +
                                                                request
                                                                    ?.applicant
                                                                    ?.lastName
                                                            }
                                                        />
                                                    ) : (
                                                        <ListItemText
                                                            primary={
                                                                statusHistory.comment ===
                                                                    "Aanvraag ingediend" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag vervolledigd" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag in behandeling genomen" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag opnieuw in behandeling genomen" ||
                                                                statusHistory.comment ===
                                                                    "Aanvraag manueel ingediend"
                                                                    ? t(
                                                                          statusHistory.comment,
                                                                      )
                                                                    : statusHistory.comment
                                                            }
                                                            secondary={dayjs(
                                                                statusHistory.creationTime,
                                                            )
                                                                .format(
                                                                    "DD/MM/YYYY",
                                                                )
                                                                .toString()}
                                                        />
                                                    )}
                                                </Box>
                                            </ListItem>
                                            {request?.statusHistories &&
                                                index + 1 !==
                                                    request.statusHistories
                                                        .length && <Divider />}
                                        </Box>
                                    ))}
                            </List>
                        </Collapse>

                        {!checkAuth(["External"]) && <Box></Box>}

                        {!checkAuth(["External"]) && (
                            <Collapse title={t("requestWithDetail.files")}>
                                <LocalFileUpload />
                            </Collapse>
                        )}

                        <Box></Box>

                        {/* {request.status === 'Geweigerd' &&
                            <div>
                                <ListItemButton {...statusListButton} onClick={handleClickInvertOpenFilesCorrespond}>
                                    <ListItemText primary={t("requestWithDetail.uploadTitleCorr")} />
                                    {openFilesCorrespond ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>

                                <Collapse in={openFilesCorrespond} timeout="auto" unmountOnExit sx={Styles.collapsedContent(theme)}>
                                    <FileUpload showMessage={showMessage} setFilesUploaded={(e) => console.log(e)}
                                        fileUploads={request.attachments.filter(a => a.isCorrespondentie === true).map(attachement => {
                                            const type = attachement.type.split('/');
                                            return {
                                                id: attachement.applicationId as string,
                                                file: new File(new Array<BlobPart>(attachement.size), attachement.name, { type: attachement.type }),
                                                progress: 100,
                                                extension: type[type.length - 1],
                                                dbId: attachement.id,

                                            };
                                        })}
                                        clickable={true}
                                        isCorrespondentie={true}
                                        textUpload={t('requestWithDetail.uploadCor')}
                                        disable={disableIfNotRefused()}
                                        backgroundColor="white"
                                        title=""
                                        getFilesChanged={updateFilesChanged}
                                    />
                                </Collapse>
                            </div>
                        } */}

                        <Box sx={{ marginBottom: "15px" }}></Box>

                        <Collapse defaultOpen title={t("steps.step3")}>
                            <Grid {...collapseGridContainer}>
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestsTableHeader.referenceCode",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.referenceCode}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t("requestWithDetail.signMethod")}
                                        </span>
                                        <br />
                                        <b>
                                            {request?.isManuallySigned
                                                ? t("requestWithDetail.manual")
                                                : request?.usedSigningMethod !==
                                                        undefined &&
                                                    request?.usedSigningMethod !==
                                                        null
                                                  ? t(
                                                        "settings.sign." +
                                                            request?.usedSigningMethod.replace(
                                                                ":",
                                                                "",
                                                            ),
                                                    )
                                                  : t(
                                                        "requestWithDetail.connective",
                                                    )}
                                        </b>
                                    </div>
                                </Grid>
                                {/* <Grid item xs={12} sm={6}>
                                    <div>
                                        <b>{t("requestsTableHeader.submissionDate")}: </b>
                                        {dayjs(request.creationTime).format("DD/MM/YYYY")}
                                    </div>
                                </Grid> */}
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step3.dateFrom",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {dayjs(request.dateFrom).format(
                                                "DD/MM/YYYY",
                                            )}
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step3.dateTo",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {dayjs(request.dateTo).format(
                                                "DD/MM/YYYY",
                                            )}
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step3.function",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.function}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step3.reason",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.reason}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step3.locations",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            <Box
                                                sx={{
                                                    marginTop: "0.1rem",
                                                }}
                                            >
                                                {request.locations.map(
                                                    (item, i) => (
                                                        <Box key={i}>
                                                            {item.name}
                                                        </Box>
                                                    ),
                                                )}
                                            </Box>
                                        </b>
                                    </div>
                                </Grid>
                            </Grid>
                        </Collapse>

                        <Box sx={{ marginBottom: "15px" }}></Box>

                        <Collapse defaultOpen title={t("steps.step1")}>
                            <Grid {...collapseGridContainer}>
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.firstName",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.applicant?.firstName}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.lastName",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.applicant?.lastName}</b>
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.birthDate",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {request.applicant?.birthDay
                                                ? dayjs(
                                                      request.applicant
                                                          ?.birthDay,
                                                  ).format("DD/MM/YYYY")
                                                : ""}
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.nationality",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.applicant?.nationality}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {request.applicant?.rrn && (
                                        <div>
                                            <span>
                                                {t(
                                                    "requestIndividual.step1.rrn",
                                                )}
                                            </span>
                                            <br />
                                            <b>{request.applicant?.rrn}</b>
                                        </div>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div>
                                        <span>
                                            {t("requestWithDetail.adress")}
                                        </span>
                                        <br />
                                        <b>
                                            {request.applicant?.address?.street}{" "}
                                            {
                                                request.applicant?.address
                                                    ?.houseNumber
                                            }{" "}
                                            {request.applicant?.address?.box}
                                            <br />
                                            {
                                                request.applicant?.address?.zip
                                            }{" "}
                                            {request.applicant?.address?.city}
                                            <br />
                                            {
                                                request.applicant?.address
                                                    ?.country
                                            }
                                        </b>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div>
                                        <span>
                                            {t("requestIndividual.step1.email")}
                                        </span>
                                        <br />
                                        <b>{request.applicant?.email}</b>
                                    </div>
                                </Grid>
                            </Grid>
                        </Collapse>

                        <Box sx={{ marginBottom: "15px" }}></Box>

                        <Collapse defaultOpen title={t("steps.step2")}>
                            <Grid {...collapseGridContainer}>
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.organizationName",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {request.responsible?.company?.name}
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.responsibleEmail",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.responsible?.email}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.responsibleFirstName",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.responsible?.firstName}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.responsibleLastName",
                                            )}
                                        </span>
                                        <br />
                                        <b>{request.responsible?.lastName}</b>
                                    </div>
                                </Grid>
                            </Grid>
                        </Collapse>

                        <Box sx={{ marginBottom: "15px" }}></Box>
                        {/* <Grid {...requestInfoWrapper} container>

                            <Grid container item spacing={2} md={6} xs={12}>
                                <Grid item xs={12}>
                                    <Box {...subtitle}>{t("steps.step3")}</Box>
                                </Grid>
                            </Grid>

                            <Grid container item spacing={2} md={6} xs={12}>
                                <Grid item xs={12}>
                                    <Box {...subtitle}>{t("steps.step1")}</Box>
                                </Grid>

                            </Grid>


                            <Grid container item spacing={2} md={6} xs={12}>
                                {checkAuth(["WeigerenAanvraag", "BeheerAanvraag"], false) &&
                                    <Grid item xs={12}>
                                        <div>
                                            <b>{t("requestWithDetail.files")}</b>
                                            <br />
                                            <ul>
                                                {request.attachments.filter(item => item.isEditable !== true && item.isManualSigned === false).map((item, i) => (
                                                    <li key={i}>
                                                        <a
                                                            href=""
                                                            role="button"
                                                            onClick={(event) => {
                                                                downloadFile(event, item);
                                                            }}
                                                        >
                                                            {item.name}{" "}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </Grid>
                                }
                            </Grid>

                            <Grid container item spacing={2} md={6} xs={12}>
                                <Grid item xs={12}>
                                    <Box {...subtitle}>{t("steps.step2")}</Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div>
                                        <b>{t("requestIndividual.step2.organizationName")}</b>
                                        <br />
                                        {request.responsible?.company?.name}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div>
                                        <b>{t("requestIndividual.step2.responsibleEmail")}</b>
                                        <br />
                                        {request.responsible?.email}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div>
                                        <b>{t("requestIndividual.step2.responsibleFirstName")}</b>
                                        <br />
                                        {request.responsible?.firstName}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div>
                                        <b>{t("requestIndividual.step2.responsibleLastName")}</b>
                                        <br />
                                        {request.responsible?.lastName}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid> */}
                    </Box>
                )}

                <Dialog
                    fullWidth
                    onClose={handleCloseInProgressDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openInProgress}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("requestWithDetail.inProgress.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleCloseInProgress}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers sx={{ textAlign: "center" }}>
                        <InProgressModal
                            request={request}
                            signingInProgress={signingInProgress}
                            openDocumentToSign={openDocumentToSign}
                            hasRead={setHasReadInProgress}
                            showMessage={showMessage}
                        />
                        {errorInProgress && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleCloseInProgress}
                        >
                            {t("requestWithDetail.cancelButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmInProgress}
                            disabled={
                                (request !== undefined &&
                                    request.applicationSignedFile &&
                                    request.applicationSignedFile?.length !==
                                        0 &&
                                    !request.isManuallySigned) ||
                                (request !== undefined &&
                                    hasReadInProgress &&
                                    request.isManuallySigned)
                                    ? false
                                    : true
                            }
                        >
                            {t("requestWithDetail.confirmButton")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth
                    onClose={handleCloseRefuseDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openRefuse}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("requestWithDetail.refuse.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleCloseRefuse}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        <Typography variant="body2" gutterBottom>
                            {t("requestWithDetail.refuse.info")}
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            label={t("requestWithDetail.refuse.label")}
                            variant="outlined"
                            fullWidth
                            multiline
                            placeholder={t(
                                "requestWithDetail.refuse.infoTextfield",
                            )}
                            rows="5"
                            value={motivationRefuse}
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                                setMotivationRefuse(event.target.value);
                            }}
                        />
                        {errorRefused && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleCloseRefuse}
                        >
                            {t("requestWithDetail.cancelButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmRefuse}
                            disabled={motivationRefuse === "" ? true : false}
                        >
                            {t("requestWithDetail.confirmButton")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth
                    onClose={handleClosePositiveDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openPositive}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("requestWithDetail.positive.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleClosePositive}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers sx={{ textAlign: "center" }}>
                        <Typography variant="body2" gutterBottom>
                            {t("requestWithDetail.positive.info")}
                        </Typography>
                        {positiveIsLoading === true && <CircularProgress />}
                        {errorPositive && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleClosePositive}
                        >
                            {t("requestWithDetail.cancelButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmPositive}
                        >
                            {t("requestWithDetail.confirmButton")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth
                    onClose={handleClosePositiveRemarkDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openPositiveRemark}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("requestWithDetail.positiveRemark.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleClosePositiveRemark}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers sx={{ textAlign: "center" }}>
                        <Typography variant="body2" gutterBottom>
                            {t("requestWithDetail.positiveRemark.info")}
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            label={t("requestWithDetail.positiveRemark.label")}
                            variant="outlined"
                            fullWidth
                            multiline
                            placeholder={t(
                                "requestWithDetail.positiveRemark.infoTextfield",
                            )}
                            rows="5"
                            value={positiveRemarkMotivation}
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                                setPositiveRemarkMotivation(event.target.value);
                            }}
                        />
                        {positiveIsLoadingRemark === true && (
                            <CircularProgress />
                        )}
                        {errorPositive && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleClosePositiveRemark}
                        >
                            {t("requestWithDetail.cancelButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmPositiveRemark}
                        >
                            {t("requestWithDetail.confirmButton")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth
                    onClose={handleCloseIncompleteDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openIncomplete}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("requestWithDetail.incomplete.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleCloseIncomplete}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        <Typography variant="body2" gutterBottom>
                            {t("requestWithDetail.incomplete.info")}
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            label={t("requestWithDetail.incomplete.label")}
                            variant="outlined"
                            fullWidth
                            multiline
                            placeholder={t(
                                "requestWithDetail.incomplete.infoTextfield",
                            )}
                            rows="5"
                            value={motivationIncomplete}
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                                setMotivationIncomplete(event.target.value);
                            }}
                        />
                        <Typography
                            variant="body2"
                            gutterBottom
                            marginTop={"0.50em"}
                        >
                            {t("requestWithDetail.incomplete.infoChecks")}
                        </Typography>
                        <IncompleteModal ref={incompleteRef} />
                        {errorIncomplete && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                        {errorNonSelected && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleCloseIncomplete}
                        >
                            {t("requestWithDetail.cancelButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmIncomplete}
                            disabled={
                                motivationIncomplete === "" ? true : false
                            }
                        >
                            {t("requestWithDetail.confirmButton")}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
            <DeleteModal
                open={openDelete}
                handleClose={handleCloseDelete}
                applicationId={applicationId}
                showMessage={showMessage}
            />
        </Box>
    );
};

export default RequestDetails;
